import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader";
import Toast from "../../utils/toast";
import "../commonLogin.css";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setLoading,
  setError,
  checkUserType,
  requestAdminOtp,
  requestOrgUserOtp,
  requestTPOtp,
} from "../../Redux/slices/authSlice";

const inputStyles = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
    backgroundColor: "#ffffff",

    "& fieldset": {
      borderColor: "rgb(37, 99, 235)",
    },

    "&:hover fieldset": {
      borderColor: "rgb(37, 99, 235)",
    },

    "&.Mui-focused fieldset": {
      borderColor: "rgb(37, 99, 235)",
      borderWidth: 2,
    },
  },

  /* 🔑 THIS IS THE KEY PART */
  "& input": {
    color: "#111827",
    padding: "14px",

    "&::placeholder": {
      color: "black",
      opacity: 1, // IMPORTANT: browsers lower this by default
      fontWeight: 500,
    },

    "&::-webkit-input-placeholder": {
      color: "black",
      opacity: 1,
    },

    "&::-moz-placeholder": {
      color: "rgb(37, 99, 235)",
      opacity: 1,
    },

    "&:-ms-input-placeholder": {
      color: "rgb(37, 99, 235)",
    },
  },

  "& .MuiInputAdornment-root i": {
    color: "rgb(37, 99, 235)",
  },

  "& .MuiFormHelperText-root": {
    color: "#dc2626",
    fontSize: "12px",
  },
};

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { loading, error, userType } = useSelector((state) => state.auth);
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({ email: "" });
  const [step, setStep] = useState("email");

  const navigate = useNavigate();

  const handleChange = (e) => {
    setEmail(e.target.value);
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const validateEmail = () => {
    if (!email) {
      setErrors({
        ...errors,
        email: "Please enter a valid email id",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateEmail()) return;

    dispatch(setLoading(true));
    try {
      // First check user type with the email
      const result = await dispatch(checkUserType(email)).unwrap();

      if (result.role === "Candidate") {
        Toast.error("Candidates should use the login page to reset password");
        return;
      }

      let otpRequestAction;
      if (result.role === "Admin") {
        otpRequestAction = requestAdminOtp(email);
      } else if (["OrgAdmin", "Interviewer", "HR"].includes(result.role)) {
        otpRequestAction = requestOrgUserOtp(email);
      } else if (result.role === "TP-Interviewer") {
        otpRequestAction = requestTPOtp(email);
      } else {
        Toast.error("User type not supported for password reset");
        return;
      }

      await dispatch(otpRequestAction).unwrap();

      // Always navigate to OTP page with role
      navigate("/otpVerification", {
        state: {
          email,
          role: result.role,
          source: "forget-password",
        },
      });

      Toast.success("OTP sent successfully");
    } catch (err) {
      Toast.error(err || "Error sending OTP. Email may not be registered.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-4">
      <h2 className="text-center" style={{ color: "rgb(37, 99, 235)" }}>
        Forgot Password
      </h2>
      <form onSubmit={handleSubmit} className="d-flex flex-column gap-4">
        <p>Please enter your Email-ID to get a one time password</p>

        <TextField
          type="email"
          name="email"
          value={email}
          placeholder="Email ID"
         
          autoFocus
          fullWidth
          onChange={handleChange}
          required
          size="small"
          variant="outlined"
          sx={inputStyles}
        />
        {errors.email && (
          <div style={{ color: "red", fontSize: "12px" }}>{errors.email}</div>
        )}

        <Button
          type="submit"
          disabled={loading}
          sx={{
            borderRadius: "12px",
            padding: "12px",
            textTransform: "none",
            fontSize: "1rem",
            fontWeight: "600",
            letterSpacing: "0.5px",
            background: "rgb(37, 99, 235)",
            // background: "linear-gradient(135deg, #e59d02, #b37a01)",
            boxShadow: "0 4px 10px rgba(0, 162, 162, 0.3)",
            "&:hover": {
              // background: "linear-gradient(135deg, #e59d02 0%, #b08b84 100%)",
              boxShadow: "0 6px 15px rgba(0, 162, 162, 0.4)",
            },
            mt: 2,
            color: "#ffffff",
          }}
        >
          {loading ? <Loader /> : "Send OTP"}{" "}
        </Button>
      </form>
      {error && <div style={{ color: "red", marginTop: "10px" }}>{error}</div>}
    </div>
  );
};

export default ForgotPassword;
